import { getWorkTypeList } from "@/services";
import { getEnums } from "@/services/homeService";
import { findAccountsDtlPageByRequest } from "@/services/insureManagement";
import { moneyRender } from "@/utils";
import { RefObject, createRef, useEffect, useState } from "react";
import { SDrawer, SLowcodeList } from "shj-components";

const Record = (props: any) => {
    const { visibleDrawer = false, title = '流水', closeDetails } = props
    const listRef: RefObject<any> = createRef();
    const [loading, setLoading] = useState(false);
    let config: any;
    config = {
        rowSelection: false,
        searchFormConfig: false,
        columns: [
            {
                title: "门店",
                dataIndex: "companyName",
                width: 160
            },
            {
                title: "姓名",
                dataIndex: "extEmpName",
                width: 100
            },
            {
                title: "技能标签",
                dataIndex: "workTypeNames",
                width: 120,
                ellipsis: true,
            },
            {
                title: "身份证号码",
                dataIndex: "idCard",
                width: 180,
            },
            {
                title: "流水类型",
                dataIndex: "costTypeName",
                width: 120
            },
            {
                title: "金额(¥)",
                dataIndex: "amount",
                width: 100,
                render: 'money'
            },
            {
                title: "创建时间",
                dataIndex: "createdTime",
                itemType: "dateTime",
                width: 160
            },
            {
                title: "费用类型",
                dataIndex: "turnoverTypeName",
                width: 160
            },
            {
                title: "账户余额(¥)",
                dataIndex: "balance",
                width: 120,
                render: 'money'
            },
            {
                title: "备注",
                dataIndex: "remarks",
                render: "remarkFn",
                ellipsis: true,
                width: 200
            },
            {
                title: "关联单号",
                dataIndex: "relatedCode",
                width: 180
            }
        ],
        search: [
            {
                name: "turnoverTypes",
                label: "费用类型",
                itemType: "select",
                key: "key",
                labelKey: "description",
                showSearch: true,
                optionFilterProp: "children",
                allowClear: true,
                mode: "multiple",
                data: "insurTurnoverTypeEnum"
            },
            {
                name: "costTypes",
                label: "流水类型",
                itemType: "select",
                key: "key",
                labelKey: "description",
                showSearch: true,
                optionFilterProp: "children",
                allowClear: true,
                mode: "multiple",
                data: "InsurCostTypeEnum"
            },
        ],
    }
    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const insurTurnoverTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurTurnoverTypeEnum")
                const InsurCostTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurCostTypeEnum")
                resolve({
                    insurTurnoverTypeEnum,
                    InsurCostTypeEnum
                });
            } catch (e) { }
        });
    };
    const fetchList = (values) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query } = values;
                query.accountId = props.accountId
                findAccountsDtlPageByRequest(current, pageSize, query).then(data => resolve(data))
            } catch (e) {
                reject({ success: false });
            }
        });
    };

    const extension = {
        request: { fetchList, getStatusOptions },
        customRender: {
            money(text: any) {
                return <span>{moneyRender(text)}</span>
            },
        }
    };
    return (
        <>
            <SDrawer
                width={1200}
                title={title}
                open={visibleDrawer}
                onClose={closeDetails}
                loading={loading}
                destroyOnClose
                footer={null}
            >
                <SLowcodeList
                    searchMode="group"
                    ref={listRef}
                    config={config}
                    {...extension}
                />
            </SDrawer>
        </>
    );
}
export default Record